import { render, staticRenderFns } from "./bracket_roundRobin.vue?vue&type=template&id=6b6316db"
import script from "./bracket_roundRobin.vue?vue&type=script&lang=js"
export * from "./bracket_roundRobin.vue?vue&type=script&lang=js"
import style0 from "./bracket_roundRobin.vue?vue&type=style&index=0&id=6b6316db&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports